<template>
	<div :id="`fold-container${elId}`" class="fold-container">
		<div class="v-container">
			<div class="tab-wrapper">
				<van-tabs
					v-model="curActiveChildCath"
					@click="handleHModeClick"
					background="#F9F9F9"
					line-width="0"
					line-height="0"
					title-inactive-color="#5A5A5A"
					title-active-color="#fff"
				>
					<van-tab v-for="(item, index) of list" :name="item.CatPath" :title="item.Name">
					</van-tab>
				</van-tabs>
			</div>
			<div class="arrow-box">
				<van-icon
					class="arrow-btn"
					:name="isExpanded ? 'arrow-up' : 'arrow-down'"
					@click="toggleExpand"
				/>
			</div>
		</div>

		<van-popup
			v-model="isExpanded"
			:transition-appear="false"
			:key="isExpanded"
			:get-container="getContainer"
			position="top"
			:overlay="false"
			duration="0"
			transition="ccc"
			:lock-scroll="false"
			:safe-area-inset-bottom="true"
		>
			<div class="expand-container">
				<div class="arrow-btn-popup-wrapper">
					<van-icon class="arrow-btn-popup" name="arrow-up" @click="toggleExpand" />
				</div>

				<tagItem
					class="tag-item"
					v-for="(item, index) of list"
					:key="index"
					:curActiveChildCath="curActiveChildCath"
					:tabName="item.Name"
					:catPath="item.CatPath"
					@click.native="selectItem(item.CatPath)"
				/>
			</div>
		</van-popup>
	</div>
</template>

<script>
import tagItem from "./tag-item.vue";
export default {
	name: "tagListUnfold",
	components: {
		tagItem,
	},
	props: {
		elId: {
			type: Number,
			default: 0,
		},
		list: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			curActiveChildCath: "",
			isExpanded: false,
			selectedIndex: 0,
		};
	},
	methods: {
		// 返回一个特定的 DOM 节点，作为挂载的父节点
		getContainer() {
			return document.querySelector(`#fold-container${this.elId}`);
		},
		toggleExpand() {
			this.isExpanded = !this.isExpanded;
		},
		handleHModeClick(name) {
			console.log('选中子分类',name)
			this.$emit("handleChildPathSelect", name);
		},
		selectItem(CatPath) {
			this.curActiveChildCath = CatPath;
			// 收起弹层
			this.isExpanded = false;
			this.$emit("handleChildPathSelect", CatPath);
		},
	},
};
</script>

<style scoped lang="less">
@com-height: 80px;
@arrow-box-width: 76px;
::v-deep .van-tabs__wrap {
	height: @com-height;
}
::v-deep .van-tab__text {
	background-color: #fff;
	font-weight: 400;
	font-size: 22px;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	height: 52px;
	padding: 0 20px;
	border-radius: 28px;
}
::v-deep .van-tab--active .van-tab__text {
	background-color: #d3ad72;
}
::v-deep .van-tab {
	padding: 0 8px;
}
// ------popup------
::v-deep .van-popup {
	position: absolute;
	max-height: unset;
}
.fold-container {
	position: relative;
	height: @com-height;
	background: #f9f9f9;
	.v-container {
		display: flex;
		height: 100%;
		.tab-wrapper {
			display: inline-block;
			width: calc(100% - @arrow-box-width);
		}
	}
}
.arrow-box {
	flex-basis: @arrow-box-width;
	display: flex;
	align-items: center;
	justify-content: center;
}
.arrow-btn {
	cursor: pointer;
}
.expand-container {
	padding-top: 14px;
	padding-bottom: 24px;
	padding-left: 24px;
	padding-right: 24px;
	position: relative;
	.arrow-btn-popup-wrapper {
		position: absolute;
		top: 0;
		right: 5px;
		cursor: pointer;
		display: inline-flex;
		width: 50px;
		height: 50px;
		justify-content: center;
		align-items: center;
		.arrow-btn-popup {
		}
	}

	.tag-item {
		margin-right: 24px;
		margin-bottom: 20px;
	}
}
</style>
